export class EventContext
{
    private _canceled: boolean = false;

    public get isCanceled(): boolean
    {
        return this._canceled;
    }

    /**
     * Stops further execution of listeners for this event.
     */
    public cancel(): void
    {
        this._canceled = true;
    }
}
